// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import DratshangAssetService from '@services/dratshang-asset'

export const getAllAccessory = createAsyncThunk('accessory/getAllAccessory', async (params, { rejectWithValue }) => {
  try {
    const response = await DratshangAssetService.getAllAccessory(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getAccessoryById = createAsyncThunk('accessory/getAccessoryById', async (id) => {
  const response = await DratshangAssetService.getAccessoryById(id)
  return response
})

export const addAccessory = createAsyncThunk('accessory/addAccessory', async (accessory, { rejectWithValue }) => {
  try {
    const response = await DratshangAssetService.addAccessory(accessory)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateAccessory = createAsyncThunk('accessory/updateAccessory', async (accessory, { rejectWithValue }) => {
  try {
    const response = await DratshangAssetService.updateAccessory(accessory)
    return response
  } catch (err) {
    rejectWithValue(err.response.data)
  }
})

export const deleteAccessory = createAsyncThunk('accessory/deleteAccessory', async (id, { dispatch, getState }) => {
  await DratshangAssetService.deleteAccessory(id)
  await dispatch(getAllAccessory(getState()?.products.params))
  return id
})

export const AccessorySlice = createSlice({
  name: 'accessories',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualAccessory: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllAccessory.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getAccessoryById.fulfilled, (state, action) => {
        state.individualAccessory = action.payload
        state.loading = false
      })
      .addCase(getAccessoryById.pending, (state, action) => {
        state.individualAccessory = action.payload
        state.loading = true
      })
      .addCase(getAccessoryById.rejected, (state, action) => {
        state.individualAccessory = action.payload
        state.loading = false
      })
  }
})

export default AccessorySlice.reducer
